module.exports = __webpack_public_path__ + "img/about_us4.76682005.png";